import React, { Component } from 'react';
import { createOperatorGroup } from '../../actions/operatorGroups';
import handleImageInput from '../../helpers/image/handleImageInput';
import ProductOperatorGroupsForm from '../../components/OperatorGroups/ProductOperatorGroupsForm';
import { connect } from 'react-redux';

class OperatorGroupsFormHOC extends Component {
  state = {
    name: '',
    warning: undefined
  };

  setField = (name, value) => {
    this.setState({
      [name]: value,
    })
  };

  handleSubmit = (evt) => {
    evt.preventDefault();
    if (!this.state.name.length) {
      this.setState({ warning: 'Please give a name to the operator group!' });
      return false;
    }

    this.props.createOperatorGroup({
      name: this.state.name,
    });
  };

  clearWarning = () => {
    this.setState({warning: undefined});
  };

  render() {
    return (
      <ProductOperatorGroupsForm
      name={this.state.name}
      formWarningOpen={this.state.warning}
      clearWarning={this.clearWarning}
      setField={this.setField}
      handleSubmit={this.handleSubmit}
      handleImageInput={handleImageInput}
    />);
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
  createOperatorGroup: (payload) => {
    dispatch(createOperatorGroup(payload))
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OperatorGroupsFormHOC);




// WEBPACK FOOTER //
// ./src/containers/OperatorGroups/OperatorGroupsFormHOC.js